module.exports = "/assets/49af64c9e4ac7ac2dbc790ed791e6c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5N.png
// module id = 1065
// module chunks = 0